export default {
      id: "icon-trophy-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg#icon-trophy",
      toString: function () {
        return this.url;
      }
    }